import React from 'react';

import cs from 'classnames';

type Props = {
  children: React.ReactNode;
  subText?: React.ReactNode;
  gray?: boolean;
};

export const ListMessage = ({
  children,
  subText,
  gray = false,
}: Props): JSX.Element => (
  <div className="text-center py-4">
    <p className={cs('lead', {'text-muted': gray})}>{children}</p>
    {subText ? <p>{subText}</p> : null}
  </div>
);
